import React from 'react'
// import { Link, PageProps } from "gatsby"
// import { StaticImage } from "gatsby-plugin-image"

// import Layout from "../components/layout"
// import SEO from "../components/seo"

import { Layout } from '@components/Layout'
import { LandingSection } from '@components/LandingSection'
import { BioSection } from '@components/BioSection'
import { WorkSection } from '@components/WorkSection'
import { ProjectSection } from '@components/ProjectSection'
import { Footer } from '@components/Footer'
import { Navbar } from '@components/Navbar'
import { ID_ABOUT, ID_WORK, ID_PROJECTS, ID_CONTACT } from '@shared/constants'

// <Layout>
//   <SEO title="Home" />
//   <h1>Hi people</h1>
//   <p>Welcome to your new Gatsby site.</p>
//   <p>Now go build something great.</p>
//   <StaticImage
//     src="../images/gatsby-astronaut.png"
//     width={300}
//     quality={95}
//     formats={["AUTO", "WEBP", "AVIF"]}
//     alt="A Gatsby astronaut"
//     style={{ marginBottom: `1.45rem` }}
//   />
//   <p>
//     <Link to="/page-2/">Go to page 2</Link> <br />
//     <Link to="/using-typescript/">Go to "Using TypeScript"</Link>
//   </p>
// </Layout>

const IndexPage = ({ }) => {
  return <Layout>
    <LandingSection />
    <Navbar />
    <BioSection id={ID_ABOUT}/>
    <WorkSection id={ID_WORK}/>
    <ProjectSection id={ID_PROJECTS}/>
    <Footer id={ID_CONTACT}/>
  </Layout>
}

export default IndexPage


